import { render } from "./CheckboxComponent.vue?vue&type=template&id=005f77d2&ts=true"
import script from "./CheckboxComponent?vue&type=script&lang=ts"
export * from "./CheckboxComponent?vue&type=script&lang=ts"

import "./_assets/_checkbox.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__